<template>
   
    <div class="container mt-2 justify-content-center">
     <div class="row ">
             <div class="col-12 mt-2">
  
              <input type="text" v-model="searchStaff" class="form-control" placeholder="ძებნა..."/>


                 <table class="table">
   <thead>
     <tr>
       <th scope="col">#</th>
       <th scope="col">სახელი გვარი</th>
       <th scope="col">თანამდებობა</th>
       <th scope="col">პირადი ნომერი</th>
       <th scope="col">მობილური</th>
       <th scope="col">მეილი</th>
       <!-- <th scope="col">კოდი</th>
       <th scope="col">პაროლი</th> -->
 
     </tr>
   </thead>
   <tbody>
    
     <tr v-for="staff in filteredStaff" :key="staff.personID">
       <th scope="row">{{ staff.personID }}</th>
       <td>{{ staff.fname }} {{ staff.lname }}</td>
       <td>{{ staff.position?staff.position.position:'' }}</td>
       <td>{{ staff.pn }}</td>
       <td>{{ staff.phone }}</td>
       <td>{{ staff.email }}</td>
       <!-- <td>{{ staff.code }}</td>
       <td>{{ staff.pass_backup }}</td> -->
       <td>
        <button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==3"  type="button" class="btn btn-outline-success"   @click="viewAndEditPersonProfile(staff.personID)"><i class='bx bx-user-circle'></i></button> 
      </td>
      <td>
        <button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==3" type="button" class="btn btn-outline-success"   @click="deleteStaff(staff.personID)"><i class='bx bx-message-x' ></i></button> 
      </td>
     </tr>
    
   </tbody>
 </table>
             </div>
 
     </div>
    </div>
  
 
 </template>
 <script>
 import HttpRequests from '../httpRequests/httpRequests'

 const httpRequests=new HttpRequests()
export default{

    data(){

      return{

          stafflist:[],
          searchStaff:'',
          filteredStaff:[]

      }

    },

    watch:{
      searchStaff(val){
        if(val!=''){

            this.filteredStaff=this.stafflist.filter(o=>o.fname.includes(val) ||  o.lname.includes(val) || o.pn.includes(val))

        }else{

          this.filteredStaff=this.stafflist
        }

      }


    },
    mounted(){

      httpRequests.getStaffList().then(response=>{

      
        this.stafflist=response.data
        this.filteredStaff=response.data
      })



    },
    methods:{
      viewAndEditPersonProfile(personID){

      window.location.href='/#/editStuff/'+personID
      },
      deleteStaff(personID){
      if(confirm('ნამდვილად გსურთ წაშლა?')){

      httpRequests.deleteStaff(personID).then(()=>{
        location.reload()
      })
}
    },
    },
    
 



}

</script>